import { type DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import * as Sentry from "@sentry/react"
import { invalidatePurchaseOrderCache, invalidatePurchaseOrderDetail } from "~Features/pages/purchaseOrders/queries/purchaseOrder.queries"
import { isClientErrorCode } from "~Shared/utils/errorHandler.utils"

export const subscribeToPurchaseOrder = async (data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    try {
        switch (operationType) {
            case OperationTypeEnum.INSERT:
            case OperationTypeEnum.UPDATE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.DELETE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.BULK_UPDATE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.UPDATE_COMMENT:
            case OperationTypeEnum.INSERT_COMMENT:
            case OperationTypeEnum.DELETE_COMMENT:
                await invalidatePurchaseOrderDetail(documentId?.toString())
                break
            case OperationTypeEnum.ATTACH_TAG:
            case OperationTypeEnum.DETACH_TAG:
                await invalidatePurchaseOrderCache()
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Purchase Order Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}

export const subscribeToPurchaseOrderCallbacks = async (data: DocumentChangeInterface) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    try {
        switch (operationType) {
            case OperationTypeEnum.INSERT:
            case OperationTypeEnum.UPDATE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.DELETE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.BULK_UPDATE:
                await invalidatePurchaseOrderCache()
                break
            case OperationTypeEnum.UPDATE_COMMENT:
            case OperationTypeEnum.INSERT_COMMENT:
            case OperationTypeEnum.DELETE_COMMENT:
                await invalidatePurchaseOrderDetail(documentId?.toString())
                break
            default:
                break
        }
    } catch (err) {
        if (isClientErrorCode(err)) {
            return
        }
        Sentry.captureException(`[Purchase Order Socket] Error: ${typeof err === "string" ? err : JSON.stringify(err)}`)
    }
}
